module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_ack_r1.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_for_r1.htm"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_int_r1.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_c01_r1.htm"
    }
  }, [_vm._v("Cocktails and Wine")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_c02_r1.htm"
    }
  }, [_vm._v("Cold Tapas")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_c03_r1.htm"
    }
  }, [_vm._v("Hot Tapas")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_c04_r1.htm"
    }
  }, [_vm._v("Main Courses and Party Dishes")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_c05_r1.htm"
    }
  }, [_vm._v("Desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_bm1_r1.htm"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780740790683_epub_bm2_r1.htm"
    }
  }, [_vm._v("Metric Conversions and Equivalents")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/viii-1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2bc86c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740790683_epub_toc_r1.vue
// module id = 72
// module chunks = 0